// Horizontal inset of every task modal section below the header row, kept in step with
// $task-modal-content-inset in task_modal.scss for the stylesheet-driven sections.
export const TASK_MODAL_CONTENT_INSET = '22px';
